import { Component, OnInit, ViewChild, ElementRef, AfterViewInit,EventEmitter, OnDestroy, Input, Output } from '@angular/core';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent implements OnInit {
  @Input() modalHeader = '';
  @Input() singleBtn = false;
  @Input() confirmModal = false;

  @Output() closeModal = new EventEmitter();
  @Output() apply = new EventEmitter();

  @ViewChild('locationPreferenceModal', { static: false }) locationPreferenceModal: ElementRef;
  elm: HTMLElement;

  ngAfterViewInit(): void {
    this.elm = this.locationPreferenceModal.nativeElement as HTMLElement;
    this.elm.classList.add('show');
    this.elm.style.width = '100vw';
    document.body.appendChild(this.el.nativeElement);
  }

  constructor(private el: ElementRef) { }

  ngOnInit(): void {
  }
  close(){
    this.closeModal.emit();
  }
  onApply(){
    this.apply.emit();
  }
  ngOnDestroy() {
    this.el.nativeElement.remove();
  }

}
